import { useStorageWithFallback } from './useStorageWithFallback'

export const useSafeLocalStorage = {
  get(key: string) {
    return useStorageWithFallback.get(key)
  },
  set(key: string, value: string) {
    useStorageWithFallback.set(key, value)
  },
  remove(key: string) {
    useStorageWithFallback.remove(key)
  }
}
